import { useSyncExternalStore } from "react"

import { isStandaloneDisplay } from "@/lib/web-push"

function subscribe(callback: () => void) {
  if (typeof window === "undefined") return () => undefined

  const standalone = window.matchMedia("(display-mode: standalone)")
  const overlay = window.matchMedia("(display-mode: window-controls-overlay)")

  standalone.addEventListener("change", callback)
  overlay.addEventListener("change", callback)

  return () => {
    standalone.removeEventListener("change", callback)
    overlay.removeEventListener("change", callback)
  }
}

export function useStandaloneDisplay() {
  return useSyncExternalStore(subscribe, isStandaloneDisplay, () => false)
}
